export default {
  delayMinutes: {
    title: '避難開始時間',
    contents: [
      { class: null, text: '避難者が災害発生時点から何分後に避難を始めるかを設定できます。' },
      { class: null, text: '例えば、和歌山県では避難困難区域抽出の際の避難開始時間を5分に設定しています。' },
      { class: null, text: '<b>出典</b> <a href="http://nigechizu.com" target="new">リンク</a>' }
    ]
  },
  speed: {
    title: '避難速度',
    contents: [
      { class: null, text: '避難者が3分間に何m移動できるかを設定できます。' },
      { class: null, text: '勾配を考慮した高齢者の歩行速度を考慮し、逃げ地図では標準避難速度を43ｍ/分（<b>129m/3分</b>）としております。夜間や雨天・積雪時などを想定する場合は歩行速度を80％（103m/3分）にするなど、調整も可能です。' },
      { class: null, text: '<b>出典</b> <a href="http://nigechizu.com" target="new">リンク</a>' }
    ]
  },
  colorNum: {
    title: '色数',
    contents: [
      { class: null, text: '逃げ道を分割する色の数を設定できます。色は避難にかかる時間を示し、緑や黄緑がより安全、茶色や黒色がより危険となります。' },
      { class: null, text: '標準は8色（緑色3分以内、黄緑色6分以内、黄色9分以内、橙色12分以内、赤色15分以内、紫色18分以内、茶色21分以内、黒色）となります。' },
      { class: null, text: '本システムでは「情報」ダイアログから「道路中心線」情報の表示をONにすることで、8色目となる黒色を表示できます。' },
      { class: null, text: '<b>出典</b> <a href="http://nigechizu.com" target="new">リンク</a>' }
    ]
  },
  safe: {
    title: '避難目標地点',
    contents: [
      { class: null, text: '避難先候補のひとつ。逃げ地図制作では、津波浸水想定区域の境界線と道路の交点を避難目標地点として設定します。' },
      { class: null, text: '本システムでは、津波浸水想定図と道路中心線のデータを利用し、交差点に避難目標地点アイコンを設置します。' },
      { class: null, text: '<b>出典</b> <a href="http://nigechizu.com" target="new">リンク</a>' }
    ]
  },
  escape: {
    title: '逃げ道',
    contents: [
      { class: null, text: '時間避難距離を示す色別道路を示します。色は避難にかかる時間を示し、緑や黄緑がより安全、茶色や黒色がより危険となります。' },
      { class: null, text: '標準は8色（緑色3分以内、黄緑色6分以内、黄色9分以内、橙色12分以内、赤色15分以内、紫色18分以内、茶色21分以内、黒色）となります。' },
      { class: null, text: '本システムでは「情報」ダイアログから「道路中心線」情報の表示をONにすることで、8色目となる黒色を表示できます。' },
      { class: null, text: '<b>出典</b> <a href="http://nigechizu.com" target="new">リンク</a>' }
    ]
  },
}



// WEBPACK FOOTER //
// ./public/config/map/params.js